import { render, staticRenderFns } from "./AppointementDetail.vue?vue&type=template&id=0cb675d5&"
import script from "./AppointementDetail.vue?vue&type=script&lang=js&"
export * from "./AppointementDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports